/**
 * Payment & Financial Icons
 * 
 * Icons for credit cards, billing, payments, and financial features.
 * 
 * Used by: Billing, payment forms, subscription management
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faCreditCard as fadCreditCard,
  faCreditCardFront as fadCreditCardFront,
  faWallet as fadWallet,
  faCoins as fadCoins,
  faCoin as fadCoin,
  faCircleDollar as fadCircleDollar,
  faDollarSign as fadDollarSign,
  faReceipt as fadReceipt,
  faMoneyBill as fadMoneyBill,
  faMoneyCheckDollarPen as fadMoneyCheckDollarPen,
  faHandHoldingDollar as fadHandHoldingDollar,
  faFileInvoiceDollar as fadFileInvoiceDollar,
  faMoneyCheckDollar as fadMoneyCheckDollar,
} from "@fortawesome/pro-duotone-svg-icons";

import {
  faCcAmex as falCcAmex,
  faCcDinersClub as falCcDinersClub,
  faCcDiscover as falCcDiscover,
  faCcJcb as falCcJcb,
  faCcMastercard as falCcMastercard,
  faCcVisa as falCcVisa,
} from "@fortawesome/free-brands-svg-icons";

import {
  faWallet as fatWallet,
} from "@fortawesome/pro-thin-svg-icons";

export const loadPaymentIcons = () => {
  // Duotone payment icons
  library.add(
    fadCreditCard,
    fadCreditCardFront,
    fadWallet,
    fadCoins,
    fadCoin,
    fadCircleDollar,
    fadDollarSign,
    fadReceipt,
    fadMoneyBill,
    fadMoneyCheckDollarPen,
    fadHandHoldingDollar,
    fadFileInvoiceDollar,
    fadMoneyCheckDollar,
  );

  // Brand credit card icons
  library.add(
    falCcAmex,
    falCcDinersClub,
    falCcDiscover,
    falCcJcb,
    falCcMastercard,
    falCcVisa,
  );

  // Thin payment icons
  library.add(fatWallet);
};
